import React from 'react';
import { Infinity as InfinityIcon } from 'lucide-react';
import { Input } from '../ui/input';
import { isUnlimitedAutoCount } from './autoBetting';

export const AutoBetCountInput = ({ id, testid, value, onChange, disabled }) => {
  const unlimited = isUnlimitedAutoCount(value);
  return <div className="original-auto-count-field" data-testid={`${testid}-field`}>
    <Input id={id} data-testid={testid} className="original-auto-input" type="text" inputMode="numeric" pattern="[0-9]*" spellCheck={false}
      value={value} onChange={(event) => onChange(event.target.value)} disabled={disabled} aria-describedby={`${id}-hint`} />
    {unlimited && <InfinityIcon size={22} className="original-auto-infinity" data-testid={`${testid}-infinity`} aria-hidden="true" />}
    <span id={`${id}-hint`} className="sr-only" data-testid={`${testid}-hint`}>0 or blank means unlimited bets until stopped. A positive whole number sets the bet count.</span>
  </div>;
};